import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const AddTestimonial = () => {
  const [formData, setFormData] = useState({
    name: '',
    message: '',
    rating: '',
    status: 'active'
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await postRequest('testimonials', formData);
      toast.success('Testimonial added successfully!', {
        position: 'top-right',
        autoClose: 2000
      });
      setTimeout(() => {
        navigate('/testimonials');
      }, 2000);
    } catch (error) {
      console.error('Failed to add testimonial:', error);
      toast.error('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Testimonial</h4>
      </div>
      <div className="mx-4">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="name">Name</label>
              <input
                id="name"
                type="text"
                name="name"
                placeholder="Enter user Name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="rating">Rating</label>
              <input
                id="rating"
                type="number"
                step="1"
                min="0"
                max="5"
                name="rating"
                placeholder='Enter rating'
                className="form-control"
                value={formData.rating}
                onChange={handleChange}
              />
            </div>
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="status">Status</label>
              <select
                id="status"
                name="status"
                className="form-control"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
            <div className="col-sm-12 mt-2">
              <label className="admin-label" htmlFor="message">Message</label>
              <textarea
                id="message"
                rows={4}
                name="message"
                placeholder='Enter message'
                className="form-control"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
          </div>

          <button type="submit" className="btn addbtn mt-3">
            Save
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddTestimonial;
